<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-process-wait-dialogue">
    <el-dialog
      title=""
      :visible.sync="visible"
      append-to-body
      @close="handleClose"
      custom-class="wy-process-wait">
      <div class="new-waithing-icon"></div>
      <div class="waiting-msg">Changes succesfully made! We are updating your data...</div>
      <div class="waitting-msg-content">{{content ? content : "This process usually takes a few minutes, your changes to Conversation Topics won’t appear right away."}}</div>
      <div class="waitting-msg-detail">
        <b>ProcessID:</b><!-- //NOSONAR --> {{processId}}
      </div>
      <div class="dialog-footer">        
        <el-button class="btn-confirm active" type="primary"  @click="visible=false">OK</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'wy-process-wait-dialogue',
  data() {
    return {
      visible: false,
      processId: null,
      content: null
    }
  },

  methods: {
    showDialogue({visible, processId, content}) {
      this.visible = visible;
      this.processId = processId;
      this.content = content;
    },

    handleClose() {
      this.$root.showProcessListDrawer({visible: true, refreshList: true, duration: 5000, tab: "activities"});
    }
  },

  created() {
    this.$root.$on("fire-page-events:processWaitDialogue", (data) => {
      this.showDialogue(data);
    });
  }
});
</script>

<style lang="scss">
.wy-process-wait-dialogue {
  display: block;
}

.wy-process-wait {
  width: 620px;
  height: 330px;
  border-radius: 10px;
  margin-top: 22vh !important;

  .el-dialog__header {
    padding: 15px 20px 10px;
  }
  .el-dialog__body {
    padding: 0px 20px 25px 20px;
    text-align: center;
  }
  .el-dialog__footer {
  padding: 0px;
  }
  .waithing-icon {
    background-image: url("../assets/icons/icon_calculating_wys.png");
    background-size: 80%;
    background-position-x: 0px;
    background-position-y: -20px;
    background-repeat: no-repeat;
    margin: 0 37%;
    height: 120px;
    width: 135px;
  }
  .new-waithing-icon {
    background-image: url("../assets/icons/icon_waiting_wys.svg");
    background-size: 80%;
    background-repeat: no-repeat;
    margin: 0 37%;
    height: 100px;
    width: 158px;
    top: 260px;
  }
  .waiting-msg {
    font-size: 20px;
    font-weight: 500;
    color: var(--site-font-secondary-color);
    line-height: 23.86px;
  }
  .waitting-msg-content {
    font-size: 15px;
    padding: 16px 28px 24px 28px;
    word-break: break-word;
    font-weight: 500;
    color: var(--site-font-secondary-color);
    line-height: 22px;
  }
  .waitting-msg-detail {
    padding-bottom: 20px;
    font-weight: normal;
    color: var(--site-font-secondary-color);
  }
  .waiting-container {
    height: 39px;
    width: 63px;
    left: 443px;
    top: 5px;
    border-radius: 5px;
    padding: 10px, 20px, 10px, 20px;
  }
  .btn-confirm {
    float: right;
    background-color: #0C2837;
    padding: 7px 40px 7px 20px;
    height: 39px;
    width: 20px;
    top: 5px;
    border-radius: 5px;
  }
  .active:hover {
    /*  Making button bigger on hover  */
    //height: 50px;
    //width: 40px;
    //padding: 13px 38px 13px 22px;
    transform: scale(1.5) perspective(1px)
  }
}
</style>